import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './modules/attendance/Home';
import AttendanceLog from './modules/attendance/AttendanceLog';
import Leaves from './modules/leaves/Leaves';
import Salary from './modules/salary/Salary';
import Profile from './modules/profile/Profile';
import Layout from './components/layout/Layout';
import Login from './modules/auth/Login';
import HRDashboard from './modules/hr/HRDashboard';
import SuperAdmin from './modules/super/SuperAdmin';
import './App.css';

function App() {
  const [employee, setEmployee]   = useState(null);
  const [logoutMsg, setLogoutMsg] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('employee');
    const token = localStorage.getItem('token');
    if (saved && token) {
      setEmployee(JSON.parse(saved));
    }
  }, []);

  // Listen for auto-logout events from api.js
  useEffect(() => {
    const handleAutoLogout = (e) => {
      setEmployee(null);
      setLogoutMsg(e.detail?.reason || 'You have been logged out');
      setTimeout(() => setLogoutMsg(''), 5000);
    };
    window.addEventListener('app:logout', handleAutoLogout);
    return () => window.removeEventListener('app:logout', handleAutoLogout);
  }, []);

  const handleLogin  = (emp) => { setEmployee(emp); setLogoutMsg(''); };
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('employee');
    setEmployee(null);
  };

  // Super admin route — completely separate, always accessible
  if (window.location.pathname.startsWith('/super')) {
    return <SuperAdmin />;
  }

  if (!employee) return (
    <>
      {logoutMsg && (
        <div style={{
          position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
          background: '#1e293b', color: '#f8fafc', padding: '10px 20px',
          borderRadius: 10, fontSize: 13, fontWeight: 600, zIndex: 9999,
          boxShadow: '0 4px 16px rgba(0,0,0,0.3)', whiteSpace: 'nowrap',
        }}>
          🔒 {logoutMsg}
        </div>
      )}
      <Login onLogin={handleLogin} />
    </>
  );

  if (employee.role === 'super_admin') {
    return <SuperAdmin />;
  }

  if (employee.role === 'hr' || employee.role === 'admin') {
    return (
      <Router>
        <Routes>
          <Route path="/hr/*" element={<HRDashboard employee={employee} onLogout={handleLogout} />} />
          <Route path="*" element={<Navigate to="/hr" />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Layout employee={employee} onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Home employee={employee} />} />
          <Route path="/log" element={<AttendanceLog employee={employee} />} />
          <Route path="/leaves" element={<Leaves employee={employee} />} />
          <Route path="/salary" element={<Salary employee={employee} />} />
          <Route path="/profile" element={<Profile employee={employee} onLogout={handleLogout} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;